import React, { useContext, useEffect, useState, useRef } from "react";
import "rc-table/assets/index.css";
import Table from "rc-table";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { similaprod_fun, singleproduct } from "../../api/Pageapi";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Grid } from "swiper/modules";
import { Shimmer } from "react-shimmer";
import { object } from "yup";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Button, Badge } from "reactstrap";
import { FaShoppingCart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { FaYoutube, FaWhatsapp, FaMinus, FaPlus } from "react-icons/fa";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";



import {
  FaFolderOpen,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
  FaHeart,
  FaRegHeart,
  FaShareAlt,
  FaRegFileAlt,
} from "react-icons/fa";
import { GiRing } from "react-icons/gi";
import { AddtoWishlist_fun, RemoveWishlist_fun, GetWishlist_fun } from "../../api/wishlist_api";
import { Addtocart_fun } from "../../api/Scheme2";
import {
  decrement,
  increment,
  setWishlistCount,
  selectCountByProductId,
} from "../../store/slices/counterSlice";
import { Navigation } from "swiper/modules";
import instance from "../../Config/Config";
import { Logindetail } from "../../context/Logindetail";
import { RazorpayKeyContext } from "../../Config/razar_key";

export default function ProductDetails() {
  const [response, setresponse] = useState();
  const [IsLoading, setIsLoading] = useState(true);
  const [similar_data, setsimilar_data] = useState([]);
  const [imageid, setimageid] = useState([]);
  const [showPriceBreakup, setShowPriceBreakup] = useState(false);
  const { detail_info, token } = useContext(Logindetail);
  const [selectedGramId, setSelectedGramId] = useState("");
  const isInitialGramLoad = useRef(true);
  const [isHover, setIsHover] = useState(false);



  const router = useNavigate();

  const product_id = useParams();
  const { state } = useLocation();

  const location = useLocation();
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const [similarData, setSimilarData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "/assets/images/placeholder_img.jfif";
    if (String(imagePath).startsWith("http")) return imagePath;

    const base_url_env = process.env.REACT_APP_BASE_URL || "";
    // If base URL has /api/v1/, remove it to get the site root for public/ assets
    const baseUrl = base_url_env.replace("/api/v1/", "/");
    return `${baseUrl}${imagePath}`;
  };

  const getKarat = (purity) => {
    if (!purity) return "22KT"; // default

    const value = parseFloat(purity);

    if (value >= 99) return "24KT";
    if (value >= 91) return "22KT";
    if (value >= 75) return "18KT";
    if (value >= 58) return "14KT";

    return `${value}%`;
  };

  const [cartaddshow, setAddCardshow] = useState()
  const id = location.state?.id;
  const finalPricefor = location.state?.finalPrice;
  const [videoLoaded, setVideoLoaded] = useState(false);
  const swiperRef = useRef(null);
  // const getsingle_product = async () => {
  //   singleproduct(product_id?.id)
  //     .then((res) => {
  //       setresponse(res?.data);
  //       console.log(res?.data, "single product");
  //       setIsLoading(false);
  //       setimageid(res?.data?.images[0]?.id);
  //     })

  //     .catch((err) => {
  //       console.log(err);
  //       setIsLoading(true);
  //     });
  // };


  // console.log("respone", response)




  // const {razorpayKey} = useContext(RazorpayKeyContext);
  // console.log("RAZOR KEY................",razorpayKey)

  const getsingle_product = async () => {
    setIsLoading(true);
    try {
      const params = { user_id: detail_info?.id };

      const res = await singleproduct(product_id?.id, params);

      setresponse(res?.data);
      setAddCardshow(res?.data?.cart)
      // console.log(res?.data, "");
      setimageid(res?.data?.images[0]?.id);
      // Gram slot is no longer auto-selected so user can choose
      // if (res?.data?.unit_id === 6 && res?.data?.gram_slots?.length > 0) {
      //   setSelectedGramId(res.data.gram_slots[0].id);
      // }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (product_id || state) {
      getsingle_product();
    } else {
      router(-1);
    }
  }, [product_id, state]);

  // Re-fetch price when user selects a different gram slot
  useEffect(() => {
    // Skip on initial load (gram is auto-set by getsingle_product)
    if (!selectedGramId) return;
    if (isInitialGramLoad.current) {
      isInitialGramLoad.current = false;
      return;
    }
    const fetchPriceByGram = async () => {
      try {
        const params = { user_id: detail_info?.id, gram_id: selectedGramId };
        const res = await singleproduct(product_id?.id, params);
        if (res?.data) {
          // Update only price-related fields, keep everything else intact
          setresponse(prev => ({
            ...prev,
            price: res.data.price,
            subtotal: res.data.subtotal,
            tax: res.data.tax,
            gst: res.data.gst,
            grand_total: res.data.grand_total,
            gold_rates: res.data.gold_rates,
            gold_prices: res.data.gold_prices,
            Making: res.data.Making,
            Wastage: res.data.Wastage,
            Other: res.data.Other,
          }));
        }
      } catch (err) {
        console.error('Error fetching price by gram slot:', err);
      }
    };
    fetchPriceByGram();
  }, [selectedGramId]);

  // const getsimialr_product = async () => {
  //   similaprod_fun(product_id?.id, response?.category_id)
  //     .then((res) => {

  //       setsimilar_data(res?.data);
  //       setIsLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // const getSimilarProducts = async () => {
  //   if (loading || !hasMore) return;

  //   setLoading(true);

  //    console.log(product_id,'product id',response?.category_id,)

  //   try {
  //     const res = await similaprod_fun(
  //       product_id?.id,
  //       response?.category_id,
  //       page
  //     );

  //     setSimilarData(prev => {
  //       const prevData = Array.isArray(prev) ? prev : [];
  //       const newData = Array.isArray(res?.data) ? res.data : [];
  //       return [...prevData, ...newData];
  //     });

  //     console.log(similarData,'fgdsfhsd f')


  //     // pagination control
  //     if (res.pagination.current_page >= res.pagination.last_page) {
  //       setHasMore(false);
  //     } else {
  //       setPage(prev => prev + 1);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const getSimilarProducts = async (currentPage = page) => {
    if (loading || !hasMore) return;
    setLoading(true);

    try {
      const res = await similaprod_fun(
        product_id?.id,
        response?.category_id,
        currentPage
      );

      const newData = Array.isArray(res?.data) ? res.data : [];

      setSimilarData(prev => [...prev, ...newData]);

      // Stop fetching if last page reached
      if (res.pagination.current_page >= res.pagination.last_page) {
        setHasMore(false);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   getsimialr_product();
  // }, [response]);
  // Reset similar products when response changes
  useEffect(() => {
    if (response?.category_id) {
      setSimilarData([]);
      setPage(1);
      setHasMore(true);
    }
  }, [response]);

  // Fetch similar products only when response is ready and not already loading
  useEffect(() => {
    if (response?.category_id && hasMore) {
      getSimilarProducts(page);
    }
  }, [page, response]);

  // run when page changes or when product data is loaded



  const columns = [
    {
      title: "Component",
      dataIndex: "component",
      key: "Component",
      //    render: (text, row) => (
      //   <div style={row.hasDivider ? { backgroundColor: "2px solid #ccc" } : {}}>
      //     {text}
      //   </div>
      // )
    },

    {
      title: "Gram",
      dataIndex: "gold_rate",
      key: "gold_rate",
    },
    {
      title: "price",
      dataIndex: "weight",
      key: "weight",
    },
    {
      title: "Percentage",
      dataIndex: "discount",
      key: "discount",
    },
    {
      title: "Final Value",
      dataIndex: "final_value",
      key: "final_value",
    },
  ];

  const price = "₹";
  const gm = "gm";
  const Percentage = "%"


  // const TableData = [
  //   {
  //     component: response?.gold_prices?.component ?? "-",
  //     gold_rate: response?.gold_prices?.gram != null ? `${response.gold_prices.gram} ${gm}` : "-",
  //     weight: response?.gold_prices?.gold_rate != null ? `${price} ${response.gold_prices.gold_rate}` : "-",
  //     discount: response?.gold_prices?.precentage != null ? `${response.gold_prices.precentage} ${Percentage}` : "-",
  //     final_value: response?.gold_prices?.final_value != null ? `${price} ${response.gold_prices.final_value}` : "-"
  //   },

  //   {
  //     component: response?.Making?.component ?? "-",
  //     gold_rate: response?.Making?.gram != null ? `${response.Making.gram} ${gm}` : "-",
  //     weight: response?.Making?.gold_rate != null ? `${price} ${response.Making.gold_rate}` : "-",
  //     discount: response?.Making?.precentage != null ? `${response.Making.precentage} ${Percentage}` : "-",
  //     final_value: response?.Making?.final_value != null ? `${price} ${response.Making.final_value}` : "-"

  //   },
  //   {
  //     component: response?.Wastage?.component ?? "-",
  //     gold_rate: response?.Wastage?.gram != null ? `${response.Wastage.gram} ${gm}` : "-",
  //     weight: response?.Wastage?.gold_rate != null ? `${price} ${response.Wastage.gold_rate}` : "-",
  //     discount: response?.Wastage?.precentage != null ? `${response.Wastage.precentage} ${Percentage}` : "-",
  //     final_value: response?.Wastage?.final_value != null ? `${price} ${response.Wastage.final_value}` : "-"

  //   },
  //   {
  //     component: response?.Other?.component ?? "-",
  //     gold_rate: response?.Other?.gram != null ? `${response.Other.gram} ${gm}` : "-",
  //     weight: response?.Other?.gold_rate != null ? `${price} ${response.Other.gold_rate}` : "-",
  //     discount: response?.Other?.precentage != null ? `${response.Other.precentage} ${Percentage}` : "-",
  //     final_value: response?.Other?.final_value != null ? `${price} ${response.Other.final_value}` : "-"
  //   },

  //   {
  //     component: "Total",
  //     gold_rate: "-",
  //     weight: "-",
  //     discount: "-",
  //     // final_value: response?.grand_total != null ? `${price} ${response?.grand_total}` : "-"
  //     final_value: response?.grand_total != null
  // ? `${price} ${Number(response.grand_total).toLocaleString('en-IN', {
  //     minimumFractionDigits: 2,
  //     maximumFractionDigits: 2,
  //   })}`
  // : "-"

  //   },

  // ];


  const TableData = [
    {
      component: response?.gold_prices?.component ?? "-",
      gold_rate: response?.gold_prices?.gram != null ? `${response.gold_prices.gram} ${gm}` : "-",
      weight: response?.gold_prices?.gold_rate != null ? `${price} ${response.gold_prices.gold_rate}` : "-",
      discount: response?.gold_prices?.precentage != null ? `${response.gold_prices.precentage} ${Percentage}` : "-",
      final_value:
        response?.gold_prices?.final_value != null
          ? `${price} ${Number(response.gold_prices.final_value).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
          : "-"
    },

    {
      component: response?.Making?.component ?? "-",
      gold_rate: response?.Making?.gram != null ? `${response.Making.gram} ${gm}` : "-",
      weight: response?.Making?.gold_rate != null ? `${price} ${response.Making.gold_rate}` : "-",
      discount: response?.Making?.precentage != null ? `${response.Making.precentage} ${Percentage}` : "-",
      final_value:
        response?.Making?.final_value != null
          ? `${price} ${Number(response.Making.final_value).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
          : "-"
    },

    {
      component: response?.Wastage?.component ?? "-",
      gold_rate: response?.Wastage?.gram != null ? `${response.Wastage.gram} ${gm}` : "-",
      weight: response?.Wastage?.gold_rate != null ? `${price} ${response.Wastage.gold_rate}` : "-",
      discount: response?.Wastage?.precentage != null ? `${response.Wastage.precentage} ${Percentage}` : "-",
      final_value:
        response?.Wastage?.final_value != null
          ? `${price} ${Number(response.Wastage.final_value).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
          : "-"
    },

    {
      component: response?.Other?.component ?? "-",
      gold_rate: response?.Other?.gram != null ? `${response.Other.gram} ${gm}` : "-",
      weight: response?.Other?.gold_rate != null ? `${price} ${response.Other.gold_rate}` : "-",
      discount: response?.Other?.precentage != null ? `${response.Other.precentage} ${Percentage}` : "-",
      final_value:
        response?.Other?.final_value != null
          ? `${price} ${Number(response.Other.final_value).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
          : "-"
    },

    // {
    //   component: "Total",
    //   gold_rate: "-",
    //   weight: "-",
    //   discount: "-",
    //   final_value:
    //     response?.grand_total != null
    //       ? `${price} ${Number(response.grand_total).toLocaleString('en-IN', {
    //           minimumFractionDigits: 2,
    //           maximumFractionDigits: 2,
    //         })}`
    //       : "-"
    // }

    {
      component: "SubTotal",
      gold_rate: "",
      weight: "",
      discount: "",
      hasDivider: true,
      final_value:
        response?.subtotal != null ? (
          <>
            {`${price} ${Number(response.subtotal).toLocaleString('en-IN', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}
          </>
        ) : (
          "-"
        )
    },
    {
      component: "GST",
      gold_rate: "",
      weight: "",
      discount: response?.gst != null ? (
        <>
          {response?.tax

          } %
        </>
      ) : (
        ""
      ),
      final_value:
        response?.gst != null ? (
          <>
            {`${price} ${Number(response.gst).toLocaleString('en-IN', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}
          </>
        ) : (
          "-"
        )
    },

    {
      component: "Total",
      gold_rate: "",
      weight: "",
      discount: "",
      final_value:
        response?.grand_total != null ? (
          <>
            {`${price} ${Number(response.grand_total).toLocaleString('en-IN', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}
            {/* <br />
        <small >(GST included)</small> */}
          </>
        ) : (
          "-"
        )
    }

  ];


  const dispatch = useDispatch();
  const apiData = useSelector((state) => state);

  const count = useSelector((state) => state.counter.value);

  const API_URL =
    "http://192.168.1.114/green_heap_gold/public/api/v1/add_to_cart";

  // const handleAdd = async  (productId, quantity = 1) => {
  //    try {
  //   const responseApi = await axios.post(API_URL, {
  //     item_id: id,
  //     quantity: 1,
  //     price:response?.price
  //   }, {
  //     headers: {
  //       'Authorization': `Bearer 1507|b8oQKr33kobtBCF1F47FrZim10guIRm0eD71NEFB973c0cf2`,
  //       'Content-Type': 'application/json'
  //     }
  //   });

  //   console.log('Add to cart response:', responseApi.data);
  //   dispatch(increment());
  // } catch (error) {
  //   console.error('Error adding to cart:', error.response?.data || error.message);
  // }
  // };

  const handleAdd = async (product) => {
    if (response?.unit_id === 6 && !selectedGramId) {
      toast.error("Please select a gram slot");
      return;
    }
    //  dispatch(increment());
    // setIsLoading(true);
    const payload = {
      item_id: id,
      quantity: response?.unit_id === 6 ? 1 : staticQuantity,
      ...(response?.unit_id === 6 && selectedGramId ? { gram_id: selectedGramId } : {})
      // price: response?.price
    };

    try {
      const res = await Addtocart_fun(payload);
      if (res?.result === true || res?.status === 200 || res?.status === true) {
        dispatch(increment());
        setAddCardshow(true);
        toast.success(res?.message || `Successfully Added`);
      } else {
        toast.error(res?.message || "Failed to add to cart");
      }
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to update quantity";

      toast.error(message);
      console.error("Error adding to cart:", error);
    } finally {
    }
  };

  const handleshowLoginpop = async (redirect = null) => {
    if (response?.unit_id === 6 && !selectedGramId) {
      toast.error("Please select a gram slot");
      return;
    }
    // Store pending cart action for guest users
    localStorage.setItem("pendingCartAction", JSON.stringify({
      item_id: id,
      quantity: staticQuantity,
      ...(response?.unit_id === 6 && selectedGramId ? { gram_id: selectedGramId } : {})
    }));

    if (redirect) {
      localStorage.setItem("redirectPath", redirect);
    }

    // Set Role 2 (Customer) and trigger modal
    localStorage.setItem("roleType", "2");
    const loginRole = document.getElementById("loginRole");
    if (loginRole) loginRole.value = "2";
    document.getElementById("openLoginModalNow")?.click();
  };

  const handleWishlist = async () => {
    if (!token || !detail_info) {
      // Set Role 2 (Customer) and trigger modal
      localStorage.setItem("roleType", "2");
      const loginRole = document.getElementById("loginRole");
      if (loginRole) loginRole.value = "2";
      document.getElementById("openLoginModalNow")?.click();
      return;
    }

    const isRemoving = response?.wishlist === 1 || response?.wishlist === true;
    try {
      const res = isRemoving
        ? await RemoveWishlist_fun(id)
        : await AddtoWishlist_fun(id);

      if (res?.status === 200 || res?.status === true) {
        toast.success(res?.message || (isRemoving ? "Removed from Wishlist" : "Added to Wishlist"));
        // Update local state
        setresponse(prev => ({ ...prev, wishlist: !isRemoving }));

        // Refresh wishlist count
        const wishlistRes = await GetWishlist_fun();
        dispatch(setWishlistCount(wishlistRes?.data?.length || 0));
      } else {
        toast.error(res?.message || "Failed to update wishlist");
      }
    } catch (error) {
      console.error("Wishlist error:", error);
      toast.error("Something went wrong");
    }
  };



  const handleRemove = async () => {
    if (count > 0) {
      try {
        const url = `remove_cart?product_id=${id}`;
        const responseApi = await instance.delete(url);
        dispatch(decrement());
        getsingle_product();
      } catch (error) {
        console.error(
          "Error removing cart item:",
          error.response?.data || error.message
        );
      }
    }
  };

  // console.log("response,", response)

  const [quantity, setQuantity] = useState(response?.quantity || 1);
  const [staticQuantity, setStaticQuantity] = useState(1);
  const [condition, setCondition] = useState(false)

  const incrementCart = () => {
    const newStaticQty = staticQuantity + 1;
    setStaticQuantity(newStaticQty);

    const newQty = (response?.quantity || 0) + newStaticQty;
    setQuantity(newQty);
    setCondition(true)

    // handleQuantityChange(response.id, newQty);
  };

  // console.log("quantity", quantity)

  const handleQuantityChange = async (id, newQuantity) => {
    if (newQuantity < 1) return;

    if (condition === false) {
      newQuantity = newQuantity + 1;
      // add 1 when condition is false
    }


    try {

      const res = await instance.post(`/add_to_cart`, {
        item_id: id,
        quantity: newQuantity,
        ...(response?.unit_id === 6 && selectedGramId ? { gram_id: selectedGramId } : {})
      });



      if (res.data?.result === false) {
        toast.error(res.data?.message);
        return;
      }

      setQuantity(newQuantity);
      toast.success(res.data?.message || `Quantity Updated`);
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to update quantity";

      toast.error(message);
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: response?.name,
          text: response?.meta_description,
          url: window.location.href,
        });
      } catch (error) {
      }
    } else {
      navigator.clipboard.writeText(window.location.href);
      toast.success("Link copied to clipboard!");
    }
  };

  const handleWhatsAppShare = () => {
    const url = window.location.href;
    const message = `Check out this product: ${response?.name}\n${url}`;
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, "_blank");
  };

  const handleSimilarWishlist = async (productId, isWishlisted) => {
    if (!token || !detail_info) {
      // Set Role 2 (Customer) and trigger modal
      localStorage.setItem("roleType", "2");
      const loginRole = document.getElementById("loginRole");
      if (loginRole) loginRole.value = "2";
      document.getElementById("openLoginModalNow")?.click();
      return;
    }
    try {
      const res = isWishlisted
        ? await RemoveWishlist_fun(productId)
        : await AddtoWishlist_fun(productId);

      if (res?.status === 200 || res?.status === true) {
        toast.success(res?.message || (isWishlisted ? "Removed from Wishlist" : "Added to Wishlist"));
        setSimilarData(prev => prev.map(p => p.id === productId ? { ...p, wishlist: !isWishlisted } : p));

        const wishlistRes = await GetWishlist_fun();
        dispatch(setWishlistCount(wishlistRes?.data?.length || 0));
      } else {
        toast.error(res?.message || "Failed to update wishlist");
      }
    } catch (error) {
      console.error("Similar Wishlist error:", error);
      toast.error("Something went wrong");
    }
  };

  const handleSimilarAddToCart = async (product) => {
    if (!token || !detail_info) {
      // Set Role 2 (Customer) and trigger modal
      localStorage.setItem("roleType", "2");
      const loginRole = document.getElementById("loginRole");
      if (loginRole) loginRole.value = "2";
      document.getElementById("openLoginModalNow")?.click();
      return;
    }
    if (product.cart) {
      toast.success("Already in Cart");
      return;
    }
    const payload = {
      item_id: product.id,
      quantity: 1,
    };
    try {
      const res = await Addtocart_fun(payload);
      if (res?.result === true || res?.status === 200 || res?.status === true) {
        toast.success(res?.message || `Successfully Added to Cart`);
        setSimilarData(prev => prev.map(p => p.id === product.id ? { ...p, cart: true } : p));
        dispatch(increment());
      } else {
        toast.error(res?.message || "Failed to add to cart");
      }
    } catch (error) {
      console.error("Similar AddToCart error:", error);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    setQuantity(response?.quantity || 1);
    setStaticQuantity(1);
  }, [response?.quantity]);



  const navigate = useNavigate();

  return (
    <>

      <section className="breadcamp py-3">
        <div className="container-fluid px-md-5 px-3">
          <nav aria-label="breadcrumb">
            <div className="d-flex align-items-center gap-2 mb-0 mt-3" style={{ fontSize: "14px", color: "#333" }}>
              <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} style={{ color: "#333", textDecoration: "none" }}>Home</a>
              <span className="text-muted" style={{ fontSize: "12px" }}>&gt;</span>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                navigate('/' + (response?.category_name?.toLowerCase() || 'product'), { state: { categoryId: response?.category_id } });
              }} style={{ color: "#333", textDecoration: "none" }}>
                {response?.category_name || "Category"}
              </a>
              {response?.sub_category_name && (
                <>
                  <span className="text-muted" style={{ fontSize: "12px" }}>&gt;</span>
                  <span style={{ color: "#666" }}>{response.sub_category_name}</span>
                </>
              )}
              <span className="text-muted" style={{ fontSize: "12px" }}>&gt;</span>
              <span style={{ fontWeight: "600", color: "#770f32" }}>{response?.name}</span>
            </div>
          </nav>
        </div>
      </section>

      <section className="pro_de pt-0 mt-0">
        <div className="container-fluid px-md-5 px-3">
          <div className="row mb-3 product-main-details">
            <div className="col-lg-6 col-md-6 col-sm-12 mb-3 pe-lg-5 image-column-divider">
              {IsLoading ? (
                <>
                  <div className="detail-imges mx-auto" style={{ maxWidth: "100%" }}>
                    <div className="row g-3">
                      <div className="col-lg-2 order-2 order-lg-1 horizontal-sm-vertical-lg d-flex flex-lg-column gap-2 justify-content-center">
                        <Shimmer className="rounded" width={80} height={80} />
                        <Shimmer className="rounded" width={80} height={80} />
                        <Shimmer className="rounded" width={80} height={80} />
                        <Shimmer className="rounded" width={80} height={80} />
                      </div>
                      {/* <div className="col-lg-10 order-1 order-lg-2">
                        <Shimmer className="rounded" width={"100%"} height={500} />
                      </div> */}
                      <div className="mb-3 pd-view w-100 position-relative" style={{ height: "250px", overflow: "hidden" }}>
                        <Shimmer width={250} height={250} className="rounded-top" />
                      </div>
                    </div>
                  </div>
                </>
              ) : response?.images?.length > 0 ? (
                <div className="detail-imges mx-auto" style={{ maxWidth: "100%" }}>
                  <div className="row g-3">
                    {/* Thumbnails Column */}
                    <div className="col-lg-2 order-2 order-lg-1 horizontal-sm-vertical-lg position-relative">
                      {response?.images?.length > 3 && (
                        <div
                          className="thumb-scroll-btn up"
                          onClick={() => swiperRef.current?.slidePrev()}
                          title="Scroll Up"
                        >
                          <FaChevronUp />
                        </div>
                      )}
                      <Swiper
                        direction={!isMobile ? "vertical" : "horizontal"}
                        spaceBetween={3}
                        slidesPerView={3}
                        freeMode={true}
                        navigation={false}
                        onSwiper={(swiper) => {
                          swiperRef.current = swiper;
                        }}
                        breakpoints={{
                          320: {
                            slidesPerView: 3,
                            spaceBetween: 5,
                            direction: "horizontal",
                          },
                          576: {
                            slidesPerView: 3,
                            spaceBetween: 5,
                            direction: "horizontal",
                          },
                          992: {
                            slidesPerView: 3,
                            spaceBetween: 5,
                            direction: "vertical",
                          },
                        }}
                        modules={[FreeMode, Pagination, Navigation]}
                        className="main-thumb-slider"
                        style={{ height: !isMobile ? "380px" : "auto" }}
                      >
                        {response?.images.map((data, i) => {
                          return (
                            <SwiperSlide key={i}>
                              <div className="thumb-item-wrapper">
                                <button
                                  className={
                                    imageid == data?.id
                                      ? "nav-link active rounded btn-bor w-100"
                                      : "nav-link rounded w-100"
                                  }
                                  type="button"
                                  onClick={() => {
                                    setimageid(data?.id);
                                  }}
                                >
                                  {data?.type === "image" ? (
                                    <div className="thumb-img-container">
                                      <img
                                        src={getImageUrl(data?.image)}
                                        className="thumb-img"
                                        alt="product"
                                      />
                                    </div>
                                  ) : (
                                    <div className="video-thumb position-relative thumb-img-container">
                                      {/* Placeholder while video loads */}
                                      {!videoLoaded && (
                                        <img
                                          src="/assets/images/placeholder_img.jfif"
                                          alt="placeholder"
                                          className="thumb-img"
                                        />
                                      )}

                                      {/* Actual video */}
                                      <video
                                        src={getImageUrl(data?.image)}
                                        className="thumb-img"
                                        style={{ display: videoLoaded ? "block" : "none" }}
                                        preload="metadata"
                                        onLoadedData={() => setVideoLoaded(true)}
                                      />

                                      {/* Play icon overlay */}
                                      <span className="play-icon">▶</span>
                                    </div>
                                  )}
                                </button>
                              </div>
                            </SwiperSlide>
                          );
                        })}
                      </Swiper>
                      {response?.images?.length > 3 && (
                        <div
                          className="thumb-scroll-btn down"
                          onClick={() => swiperRef.current?.slideNext()}
                          title="Scroll Down"
                        >
                          <FaChevronDown />
                        </div>
                      )}
                    </div>

                    {/* Main Image Column */}
                    <div className="col-lg-10 order-1 order-lg-2">
                      <div
                        className="tab-content border rounded main-image-container"
                        id="pills-tabContent"
                      >
                        {response?.images.map((data, index) => {
                          const isActive = imageid == data?.id;

                          return (
                            <div
                              key={data?.id}
                              className={
                                isActive
                                  ? "tab-pane fade show active text-align-center d-flex justify-content-center h-100"
                                  : "tab-pane fade text-align-center h-100"
                              }
                              id={`${data?.id}`}
                              role="tabpanel"
                              tabIndex="0"
                              style={{ height: "100%", width: "100%" }}
                            >
                              {data?.type === "image" ? (
                                isMobile ? (
                                  <TransformWrapper
                                    minScale={1}
                                    maxScale={3}
                                    initialScale={1}
                                    centerOnInit
                                    doubleClick={{ mode: "toggle", step: 1.5 }}
                                    pinch={{ step: 5 }}
                                    panning={{ velocityDisabled: true }}
                                    wrapperStyle={{ width: "100%", height: "100%" }}
                                    contentStyle={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
                                  >
                                    <TransformComponent>
                                      <img
                                        src={getImageUrl(data?.image)}
                                        alt="product"
                                        className="img-fluid"
                                        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", touchAction: "none" }}
                                      />
                                    </TransformComponent>
                                  </TransformWrapper>
                                ) : (
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      overflow: "hidden",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: isHover ? "zoom-out" : "zoom-in",
                                    }}
                                    onMouseEnter={() => setIsHover(true)}
                                    onMouseLeave={() => setIsHover(false)}
                                    onMouseMove={(e) => {
                                      if (!isHover) return;
                                      const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
                                      const x = ((e.clientX - left) / width) * 100;
                                      const y = ((e.clientY - top) / height) * 100;
                                      e.currentTarget.querySelector("img").style.transformOrigin = `${x}% ${y}%`;
                                    }}
                                  >
                                    <img
                                      src={getImageUrl(data?.image)}
                                      alt="product"
                                      className="img-fluid"
                                      style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                        transition: "transform 0.3s ease",
                                        transform: isHover ? "scale(2)" : "scale(1)",
                                      }}
                                    />
                                  </div>
                                )
                              ) : data?.type === "video" ? (
                                <video
                                  src={getImageUrl(data?.image)}
                                  className="img-fluid"
                                  style={{ maxHeight: "100%", objectFit: "contain" }}
                                  controls
                                  controlsList="nodownload noplaybackrate"
                                  autoPlay={isActive}
                                  loop
                                  playsInline
                                  preload="metadata"
                                />
                              ) : ""}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  {/* <Swiper
                    spaceBetween={10}
                    slidesPerView={5}
                    freeMode={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      576: { slidesPerView: 2 },
                      992: { slidesPerView: 4 },
                      1200: { slidesPerView: 3 },
                    }}
                    modules={[FreeMode, Pagination]}
                    className="main_slider33"
                  >
                    {response?.images.map((data) => (
                      <SwiperSlide key={data.id}>
                        <div>
                          <button
                            className={
                              imageid == data?.id
                                ? "nav-link active rounded btn-bor"
                                : "nav-link rounded"
                            }
                            type="button"
                            onClick={() => setimageid(data?.id)}
                          >
                            {data?.type === "image" ? (
                              <img
                                src={data?.image}
                                className="img-fluid"
                                alt="product"
                              />
                            ) : (
                               <div className="video-thumb position-relative">
                                <video
                                  src={data?.image}
                                  className="img-fluid"
                               
                                />
                                <span className="play-icon">▶</span>
                              </div>

                            )}
                          </button>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper> */}

                </div>
              ) : (
                ""
              )}
            </div>
            <div className="col-lg-6 col-md-6  col-sm-12 mb-3">
              {IsLoading ? (
                <div className="prdd prdd-load mt-sm-3 p-3 mb-lg-2 ">
                  <h2 className="mb-4 ">
                    {" "}
                    <Shimmer
                      width={330}
                      height={40}
                      className="rounded"
                    ></Shimmer>
                  </h2>
                  <div className="d-flex gap-4 mb-4">
                    <Shimmer width={150} height={40} className="rounded" />
                  </div>
                  <div className="row mb-3 g-4">
                    <div className="col-md-6 col-6">
                      <div className="d-flex align-items-center gap-3">
                        <Shimmer width={40} height={40} className="rounded-circle" />
                        <Shimmer width={100} height={20} className="rounded" />
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="d-flex align-items-center gap-3">
                        <Shimmer width={40} height={40} className="rounded-circle" />
                        <Shimmer width={100} height={20} className="rounded" />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3 g-4">
                    <div className="col-md-6 col-6">
                      <div className="d-flex align-items-center gap-3">
                        <Shimmer width={40} height={40} className="rounded-circle" />
                        <Shimmer width={100} height={20} className="rounded" />
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="d-flex align-items-center gap-3">
                        <Shimmer width={40} height={40} className="rounded-circle" />
                        <Shimmer width={100} height={20} className="rounded" />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3 g-4">
                    <div className="col-md-6 col-6">
                      <div className="d-flex align-items-center gap-3">
                        <Shimmer width={40} height={40} className="rounded-circle" />
                        <Shimmer width={100} height={20} className="rounded" />
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="d-flex align-items-center gap-3">
                        <Shimmer width={40} height={40} className="rounded-circle" />
                        <Shimmer width={100} height={20} className="rounded" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 mt-4">
                    <Shimmer width={150} height={50} className="rounded-pill" />
                    <Shimmer width={50} height={50} className="rounded-circle" />
                  </div>
                </div>
              ) : (
                <div className="prdd Prdd2 mt-0">
                  <div className="d-flex justify-content-between align-items-center position-relative w-100 mb-2">
                    <div className="mb-2">
                      <span className="text-muted small fw-bold" style={{ letterSpacing: "1px" }}>
                        SKU: {response?.Sku || "N/A"}
                      </span>
                    </div>

                    <div className="top-action-bar d-flex gap-2 mobile-only-action">
                      {/* Share Button */}
                      <button className="action-pill-btn" onClick={handleShare} title="Share">
                        <FaShareAlt />
                      </button>

                      {/* Wishlist Button */}
                      <button
                        className={`action-pill-btn ${response?.wishlist ? 'active' : ''}`}
                        onClick={handleWishlist}
                        title={response?.wishlist ? "Wishlisted" : "Wishlist"}
                      >
                        {response?.wishlist ? <FaHeart /> : <FaRegHeart />}
                      </button>

                    </div>
                  </div>
                  <h1 className="fw-bold mb-3 pe-5" style={{ fontSize: "32px", color: "#222", fontFamily: "serif" }}>{response?.name ? response?.name : ""}</h1>

                  <div className="d-flex align-items-center gap-4 mb-4">
                    <div className="d-flex align-items-center gap-3">
                      <h2 className="text-color2 fw-bold mb-0" style={{ fontSize: "36px" }}>
                        {response?.subtotal ? `${price}${Number(response?.subtotal).toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}` : ""}
                      </h2>
                      {response?.before_discount > 0 && (
                        <span className="text-muted text-decoration-line-through" style={{ fontSize: "22px" }}>
                          {price}{Number(response.before_discount).toLocaleString('en-IN', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      )}
                    </div>
                    {response?.before_discount > 0 && (
                      <div className="badge-wrapper">
                        <span className="badge bg-danger px-3 py-2 rounded-pill" style={{ fontSize: "12px", fontWeight: "600" }}>On Offer</span>
                      </div>
                    )}
                  </div>

                  <div className="product-attributes mb-4">
                    <div className="row g-4">
                      <div className="col-md-6 col-6">
                        <div className="d-flex align-items-center gap-3">
                          <div className="attr-icon-simple">
                            <img src="/assets/iocns/material.png" alt="material" />
                          </div>
                          <div className="d-flex flex-column">
                            <span className="fw-bold text-dark attr-value">{response?.material_name || "Yellow Gold"}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-6">
                        <div className="d-flex align-items-center gap-3">
                          <div className="attr-icon-simple">
                            <img src="/assets/iocns/purity.png" alt="purity" />
                          </div>
                          <div className="d-flex flex-column">
                            <span className="fw-bold text-dark attr-value">{response?.gold_purity
                              ? `${response.gold_purity} (${getKarat(response.gold_purity)})`
                              : "91.6 (22KT)"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-6">
                        <div className="d-flex align-items-center gap-3">
                          <div className="attr-icon-simple">
                            <img src="/assets/iocns/quality.png" alt="quality" />

                          </div>
                          <div className="d-flex flex-column">
                            <span className="fw-bold text-dark attr-value">{response?.quality || "916 Hallmark"}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-6">
                        <div className="d-flex align-items-center gap-3">
                          <div className="attr-icon-simple">
                            <img src="/assets/iocns/gream_weight.png" alt="gram weight" />
                          </div>
                          <div className="d-flex flex-column">
                            <span className="fw-bold text-dark attr-value">{response?.gold_prices?.gram ? response?.gold_prices?.gram + " Grams" : response?.unit_name || "Piece (pc)"}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-6">
                        <div className="d-flex align-items-center gap-3">
                          <div className="attr-icon-simple">
                            <img src="/assets/iocns/metalcolor.png" alt="metal color" />
                          </div>
                          <div className="d-flex flex-column">
                            <span className="fw-bold text-dark attr-value">{response?.metal_colour_name || "N/A"}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-6">
                        <div className="d-flex align-items-center gap-3">
                          <div className="attr-icon-simple">
                            <img src={response?.gender_name?.toLowerCase() === 'female' ? '/assets/iocns/female.png' : response?.gender_name?.toLowerCase() === 'male' ? '/assets/iocns/male.png' : '/assets/iocns/neutral.png'} alt="gender" />
                          </div>
                          <div className="d-flex flex-column">
                            <span className="fw-bold text-dark attr-value">{response?.gender_name || "N/A"}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {response?.is_sold === 1 ? (
                    <div className="mt-4">
                      <span className="badge bg-danger px-4 py-2 fs-6 rounded-pill">Sold Out</span>
                    </div>
                  ) : (
                    <>
                      {response?.unit_id === 6 && response?.gram_slots?.length > 0 && (
                        <div className="gram-slots-dropdown mb-4">
                          <label className="fw-bold mb-2" style={{ color: "#770f32" }}>Select Gram Slot</label>
                          <div className="position-relative">
                            <select
                              className="form-select premium-select"
                              value={selectedGramId || ""}
                              onChange={(e) => setSelectedGramId(e.target.value)}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 15px",
                                border: "1px solid #770f3220",
                                background: "#fdf8f9",
                                color: "#333",
                                fontSize: "15px",
                                fontWeight: "500",
                                cursor: "pointer",
                                appearance: "none",
                                WebkitAppearance: "none",
                                width: "100%",
                                maxWidth: "300px"
                              }}
                            >
                              <option value="" disabled hidden>Select a gram</option>
                              {response.gram_slots.map((slot) => (
                                <option key={slot.id} value={slot.id}>
                                  {slot.slot_label}g
                                </option>
                              ))}
                            </select>
                            <div className="select-arrow" style={{
                              position: "absolute",
                              right: "15px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              color: "#770f32"
                            }}>
                              {/* <FaChevronDown size={12} /> */}
                            </div>
                          </div>
                        </div>
                      )}
                      {detail_info && token && response?.unit_id !== 6 && (
                        <div className="d-flex align-items-center mt-4 mb-3 sm-prdd2" style={{ gap: '10rem' }}>
                          <div>
                            <h5 className="mb-0">Quantity</h5>
                          </div>
                          <div className="premium-quantity-selector">
                            <button
                              onClick={() => {
                                setQuantity(quantity - 1)
                                setStaticQuantity(staticQuantity - 1)
                              }}
                              disabled={staticQuantity < 2}
                            >
                              <FaMinus size={14} />
                            </button>
                            <div className="quantity-value">
                              {staticQuantity}
                            </div>
                            <button
                              onClick={incrementCart}
                            >
                              <FaPlus size={14} />
                            </button>
                          </div>
                          {/* Desktop only Share/Wishlist */}
                          <div className="desktop-only-action gap-2 ms-4">
                            <button className="action-pill-btn" onClick={handleShare} title="Share">
                              <FaShareAlt />
                            </button>
                            <button
                              className={`action-pill-btn ${response?.wishlist ? 'active' : ''}`}
                              onClick={handleWishlist}
                              title={response?.wishlist ? "Wishlisted" : "Wishlist"}
                            >
                              {response?.wishlist ? <FaHeart /> : <FaRegHeart />}
                            </button>
                          </div>
                        </div>
                      )}
                      {!detail_info && !token && response?.unit_id !== 6 && (
                        <div className="d-flex align-items-center mt-4 mb-3 sm-prdd2" style={{ gap: '10rem' }}>
                          <div>
                            <h5 className="mb-0">Quantity</h5>
                          </div>
                          <div className="premium-quantity-selector">
                            <button
                              onClick={() => {
                                if (staticQuantity > 1) {
                                  setStaticQuantity(staticQuantity - 1);
                                }
                              }}
                              disabled={staticQuantity <= 1}
                            >
                              <FaMinus size={14} />
                            </button>
                            <div className="quantity-value">
                              {staticQuantity}
                            </div>
                            <button
                              onClick={() => setStaticQuantity(staticQuantity + 1)}
                            >
                              <FaPlus size={14} />
                            </button>
                          </div>
                          {/* Desktop only Share/Wishlist for guests */}
                          <div className="desktop-only-action gap-2 ms-4">
                            <button className="action-pill-btn" onClick={handleShare} title="Share">
                              <FaShareAlt />
                            </button>
                            <button
                              className={`action-pill-btn ${response?.wishlist ? 'active' : ''}`}
                              onClick={handleWishlist}
                              title={response?.wishlist ? "Wishlisted" : "Wishlist"}
                            >
                              {response?.wishlist ? <FaHeart /> : <FaRegHeart />}
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {response?.is_sold !== 1 && (
                    <div className="d-flex align-items-center gap-3 flex-wrap mt-4">
                      <button
                        className="btn-add-to-cart-large"
                        onClick={() => {
                          if (token && detail_info) {
                            if (response?.unit_id === 6) {
                              handleAdd(); // ONLY add
                            } else {
                              if (cartaddshow) {
                                handleQuantityChange(response.id, quantity);
                              } else {
                                handleAdd();
                              }
                            }
                          } else {
                            handleshowLoginpop("/cart");
                          }
                        }}
                      >
                        <FaShoppingCart />
                        <span>
                          {response?.unit_id === 6
                            ? "Add to Cart"
                            : cartaddshow
                              ? "Update Cart"
                              : "Add to Cart"}
                        </span>
                      </button>

                      <div className="d-flex gap-3 align-items-center">
                        <div
                          className="social-action-pill whatsapp"
                          onClick={handleWhatsAppShare}
                          title="Share on WhatsApp"
                        >
                          <FaWhatsapp />
                        </div>
                        {response?.youtube_url && (
                          <a
                            href={response.youtube_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-action-pill youtube"
                            title="Watch on YouTube"
                          >
                            <FaYoutube style={{ color: 'red' }} />
                          </a>
                        )}
                      </div>
                    </div>
                  )}

                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="price-break section-gap-top">
        <div className="container-fluid px-md-5 px-3 details-aligned-container">
          {/* Trust Indicators Section */}
          {!IsLoading && (
            <div className="rerfs-container">
              <div className="rerfs d-flex justify-content-evenly text-center align-items-center mb-0 mt-4">
                <div className="trust-item d-flex flex-column gap-1">
                  <div className="refreimg">
                    <img src="/assets/iocns/hallmark_1.png" alt="hallmark" />
                  </div>
                  <h6 className="trust-title">BIS Hallmark Jewellery</h6>
                  <p className="trust-subtitle">Authenticity & Purity Assured</p>
                </div>

                <div className="trust-item d-flex flex-column gap-1">
                  <div className="refreimg">
                    <img src="/assets/iocns/pure gold.png" alt="gold" />
                  </div>
                  <h6 className="trust-title">Quality Guaranteed</h6>
                  <p className="trust-subtitle">24K Pure Gold / 92.5 Silver</p>
                </div>

                <div className="trust-item d-flex flex-column gap-1">
                  <div className="refreimg">
                    <img src="/assets/iocns/secure delivery.png" alt="delivery" />
                  </div>
                  <h6 className="trust-title">100% Secure</h6>
                  <p className="trust-subtitle">Safe & Secure Doorstep Delivery</p>
                </div>

                <div className="trust-item d-flex flex-column gap-1">
                  <div className="refreimg">
                    <img src="/assets/iocns/best price.png" alt="price" />
                  </div>
                  <h6 className="trust-title">Best Prices</h6>
                  <p className="trust-subtitle">Competitive Market Rates</p>
                </div>

                {/* <div className="trust-item d-flex flex-column gap-1">
  <div className="refreimg">
    <img src="/assets/images/store.png" alt="franchise locator"  />
  </div>
  <h6 className="trust-title">Franchise Locator</h6>
  <p className="trust-subtitle">Find in Nearby Franchise</p>
</div>
                 */}
                <div
                  className="trust-item d-flex flex-column gap-1"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/franchise")}
                >
                  <div className="refreimg">
                    <img src="/assets/iocns/shop-2.png" alt="franchise locator" />
                  </div>
                  <h6 className="trust-title">Franchise Locator</h6>
                  <p className="trust-subtitle">Find in Nearby Franchise</p>
                </div>
              </div>
            </div>


          )}


          {IsLoading ? (
            <div className="description-section-card productdetail-shimmer ">
              <div className="description-card-header">
                <FaRegFileAlt />
                <Shimmer height={30} width={200} className="rounded" />
              </div>
              <div className="description-card-content">
                <div className="lh-base fw-normal">
                  <Shimmer height={20} width={860} className="rounded mb-2" />
                  <Shimmer height={20} width={800} className="rounded mb-2" />
                  <Shimmer height={20} width={830} className="rounded mb-2" />
                </div>
                <div className="lh-base fw-normal mt-3">
                  <Shimmer height={20} width={860} className="rounded mb-2" />
                  <Shimmer height={20} width={810} className="rounded mb-2" />
                </div>
              </div>
            </div>
          ) : (
            <div className="description-section-card">
              <div className="description-card-header">
                <FaRegFileAlt />
                <h3>Product Description</h3>
              </div>
              <div className="description-card-content">
                <div
                  className="lh-base fw-normal prod-description-content"
                  dangerouslySetInnerHTML={{ __html: response?.description || "A masterfully crafted piece designed with precision and elegance to complement your style." }}
                ></div>

                {/* YouTube button moved below product images */}
              </div>
            </div>
          )}
          {response?.gold_rates?.length > 0 && (
            <>
              <div className="section-header-inline w-100 d-flex align-items-center gap-3">
                <h2 className="fw-bold mb-0 mt-5">Price Break Up</h2>
                <button
                  className="btn-show-more"
                  onClick={() => setShowPriceBreakup(!showPriceBreakup)}
                >
                  {showPriceBreakup ? "HIDE DETAILS" : "SHOW MORE"}
                  {showPriceBreakup ? <FaChevronUp /> : <FaChevronDown />}
                </button>
              </div>
            </>
          )}

          {showPriceBreakup && (
            <div className="w-100">
              <table className="table d-none table-borderless">
                <thead>
                  <tr>
                    <th scope="col">Component</th>
                    <th scope="col">Gold Rate(18KT)</th>
                    <th scope="col">Weight (g)</th>
                    <th scope="col">Discount</th>
                    <th scope="col">Final Value</th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  <tr>
                    <td>18KT Plain Gold</td>
                    <td>Rs 5650.36/g</td>
                    <td>4.322g</td>
                    <td>-</td>
                    <td>Rs 24420.86</td>
                  </tr>
                  <tr>
                    <td>Stone Detail</td>
                    <td>-</td>
                    <td>5.595 ct/ 1.119 g</td>
                    <td>-</td>
                    <td>Rs 54425.1</td>
                  </tr>
                  <tr>
                    <td>Making Charges</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>Rs 18899.00</td>
                  </tr>
                  <tr>
                    <td>Sub Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Rs 97744.96</td>
                  </tr>
                  <tr>
                    <td>GST</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Rs 2932.35</td>
                  </tr>{" "}
                </tbody>
              </table>
              {IsLoading ? (
                <div className="siptable-view mt-4">
                  <table className="table border rounded">
                    <thead>
                      <tr className="pd-tableload">
                        <th scope="col" className="h5 text-center">
                          <Shimmer height={20} width={80} className="rounded d-inline-block" />
                        </th>
                        <th scope="col" className="h5 text-center">
                          <Shimmer height={20} width={80} className="rounded d-inline-block" />
                        </th>
                        <th scope="col" className="h5 text-center">
                          <Shimmer height={20} width={80} className="rounded d-inline-block" />
                        </th>
                        <th scope="col" className="h5 text-center">
                          <Shimmer height={20} width={80} className="rounded d-inline-block" />
                        </th>
                        <th scope="col" className="h5 text-center">
                          <Shimmer height={20} width={80} className="rounded d-inline-block" />
                        </th>
                      </tr>
                    </thead>

                    <tbody className=" border rounded">
                      {Array.from({ length: 5 }).map((_, i) => {
                        return (
                          <tr className="text-center" key={i}>
                            <td className="text-center py-3">
                              <Shimmer
                                height={20}
                                width={120}
                                className="rounded ms-2 d-inline-block"
                              />
                            </td>
                            <td className="text-center py-3">
                              <Shimmer
                                height={20}
                                width={100}
                                className="rounded d-inline-block"
                              />
                            </td>
                            <td className="text-center py-3">
                              <Shimmer
                                height={20}
                                width={100}
                                className="rounded d-inline-block"
                              />
                            </td>
                            <td className="text-center py-3">
                              <Shimmer
                                height={20}
                                width={100}
                                className="rounded d-inline-block"
                              />
                            </td>
                            <td className="text-center py-3">
                              <Shimmer
                                height={20}
                                width={100}
                                className="rounded d-inline-block"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : response?.gold_rates?.length > 0 ? (
                <Table
                  scroll={{ x: 650 }}
                  columns={columns}
                  // data={response?.gold_rates}
                  data={TableData}
                  rowClassName={(record) => {
                    if (record.component === "GST") return "highlight-gst";
                    if (record.component === "SubTotal") return "highlight-subtotal";
                    if (record.component === "Total") return "highlight-total";
                    return "";
                  }}
                  aria-labelledby="lblPeopleTable"
                />
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </section>

      {IsLoading ? (
        <>
          <div className="container-fluid px-md-5 px-3 price-break w-100">
            <h2 className="fw-bold mb-4">Similar Products you may like</h2>
            <div className="row">
              {Array.from({ length: 4 }).map((_, i) => {
                return (
                  <div
                    className="col-xxl-2 col-xl-3  col-lg-3 col-md-3 mb-4 col-sm-6"
                    key={i}
                  >
                    <div className="simlar_pr  rounded-3 px-3">
                      <div className="mb-3 pd-view w-100 position-relative" style={{ height: "250px", overflow: "hidden" }}>
                        <Shimmer width={"100%"} height={"100%"} className="rounded-top" />
                      </div>
                      <div className="d-flex flex-column gap-2 justify-content-center p-3">
                        <Shimmer width={"80%"} height={20} className="rounded" />
                        <Shimmer width={"40%"} height={15} className="rounded" />
                        <Shimmer width={"60%"} height={25} className="rounded" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      ) : (
        similarData.length > 0 && (
          <section className="price-break section-gap-top">
            <div className="container-fluid px-md-5 px-3 sim w-100 details-aligned-container">
              <h2 className="fw-bold mb-4">Similar Products you may like</h2>

              <Swiper
                spaceBetween={10}
                slidesPerView={5}
                slidesPerGroup={2}
                freeMode={false}
                onReachEnd={() => {
                  if (!loading && hasMore) setPage((prev) => prev + 1);
                }}
                breakpoints={{
                  320: { slidesPerView: 1, slidesPerGroup: 1 },
                  576: { slidesPerView: 2, slidesPerGroup: 2 },
                  992: { slidesPerView: 3, slidesPerGroup: 3 },
                  1200: { slidesPerView: 5, slidesPerGroup: 3 },
                }}
                pagination={{ clickable: true }}
                modules={[FreeMode]}
                className="main_slider"
              >
                {similarData.map((res, i) => (
                  <SwiperSlide key={i}>
                    <div className="gp_lst border position-relative h-100 p-2 mx-1 overflow-hidden">
                      {res?.is_sold == 1 && (
                        <div className="sold-out-stamp">Sold Out</div>
                      )}
                      <div className={res?.is_sold == 1 ? "product-sold-out-content" : ""}>
                        {/* Floating Wishlist Button */}
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSimilarWishlist(res?.id, res?.wishlist);
                          }}
                          className="wishlist-btn-float"
                        >
                          {res?.wishlist ? (
                            <FaHeart style={{ color: "#991313" }} />
                          ) : (
                            <FaRegHeart />
                          )}
                        </button>

                        {/* Image Container */}
                        <div
                          className="mb-3 d-flex justify-content-center pd-view"
                          onClick={() => {
                            window.scrollTo(0, 0);
                            router(`/detail/${res.slug}`, {
                              state: { id: res.id },
                            });
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={getImageUrl(res.image)} alt={res.name} className="img-fluid" />
                        </div>

                        {/* Product Info */}
                        <div
                          className="d-flex flex-column gap-1 justify-content-center"
                          onClick={() => {
                            window.scrollTo(0, 0);
                            router(`/detail/${res.slug}`, {
                              state: { id: res.id },
                            });
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <h5 className="fw-bold one_line text-start px-2 mb-1" style={{ fontSize: "16px" }}>
                            {res?.name}
                          </h5>

                          <div className="d-flex flex-column align-items-start px-2">
                            <h6 className="mb-0" style={{
                              textDecoration: "line-through",
                              color: "#888",
                              fontSize: "14px",
                              display: res?.before_discount > 0 ? "block" : "none"
                            }}>
                              {Number(res?.before_discount).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                                maximumFractionDigits: 0
                              })}
                            </h6>
                            <h6 className="text-color fw-bold mb-0" style={{ fontSize: "18px" }}>
                              {Number(res?.price).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                                maximumFractionDigits: 0
                              })}
                            </h6>
                          </div>
                        </div>

                        {/* Floating Cart Button */}
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSimilarAddToCart(res);
                          }}
                          className="cart-btn-float"
                          style={{ cursor: "pointer" }}
                        >
                          {res?.cart ? (
                            <FaShoppingCart style={{ color: "#650020" }} />
                          ) : (
                            <HiOutlineShoppingCart />
                          )}
                        </button>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}


                {loading && hasMore && (
                  <SwiperSlide>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "200px" }} // same approximate height as slides
                    >
                      <div className="spinner-border text-danger" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </SwiperSlide>
                )}
              </Swiper>
            </div>
          </section>
        )
      )}
    </>
  );
}
